import { render, staticRenderFns } from "./ServiceSchoolsSidebar.vue?vue&type=template&id=9bc2b9c8&scoped=true"
import script from "./ServiceSchoolsSidebar.vue?vue&type=script&lang=js"
export * from "./ServiceSchoolsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ServiceSchoolsSidebar.vue?vue&type=style&index=0&id=9bc2b9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc2b9c8",
  null
  
)

export default component.exports